import classNames from 'classnames';
import PropTypes from 'prop-types';
import { PRIMARY } from '../../../constants/color';

const ChannelItem = ({ Icon, title, checked }) => {
  return (
    <div
      className={classNames(
        'flex flex-col justify-center items-center border rounded cursor-pointer text-center w-full h-full',
        checked ? `bg-[#1b433226] border-[#1B4332] text-[${PRIMARY}]` : 'border-[#84818A] text-[#84818A]',
      )}
    >
      <Icon width='24' />
      <p className='mt-1 text-[12px]'>{title}</p>
    </div>
  );
};

ChannelItem.propTypes = {
  Icon: PropTypes.oneOfType([PropTypes.func, PropTypes.elementType]),
  title: PropTypes.string,
  onClick: PropTypes.func,
  checked: PropTypes.bool,
};

export default ChannelItem;
